import { FC } from 'react';
import CrossSvg from '@edikk-edikk/country-layout-black-icon/src/cross.svg';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import { Button, ButtonSize, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useIsFrontendStyleDefault } from '@edikk-edikk/country-frontend';
import { useAdvertDetailContext } from '#advertDetail/hooks';

const GalleryHeaderClose: FC = () => {
  const { onClose } = useAdvertDetailContext();
  const isFrontendStyleDefault = useIsFrontendStyleDefault();

  if (!onClose) {
    return null;
  }

  return (
    <Button
      variant={isFrontendStyleDefault ? ButtonVariant.black : ButtonVariant.blackRose}
      size={ButtonSize.lg}
      circle
      onClick={onClose}
      aria-label="Close"
    >
      <SvgIcon Component={CrossSvg} isWithoutFill />
    </Button>
  );
};

export { GalleryHeaderClose };
